export const violet = {
  1: { value: { base: '{colors.violet.light.1}', _dark: '{colors.violet.dark.1}' } },
  2: { value: { base: '{colors.violet.light.2}', _dark: '{colors.violet.dark.2}' } },
  3: { value: { base: '{colors.violet.light.3}', _dark: '{colors.violet.dark.3}' } },
  4: { value: { base: '{colors.violet.light.4}', _dark: '{colors.violet.dark.4}' } },
  5: { value: { base: '{colors.violet.light.5}', _dark: '{colors.violet.dark.5}' } },
  6: { value: { base: '{colors.violet.light.6}', _dark: '{colors.violet.dark.6}' } },
  7: { value: { base: '{colors.violet.light.7}', _dark: '{colors.violet.dark.7}' } },
  8: { value: { base: '{colors.violet.light.8}', _dark: '{colors.violet.dark.8}' } },
  9: { value: { base: '{colors.violet.light.9}', _dark: '{colors.violet.dark.9}' } },
  10: { value: { base: '{colors.violet.light.10}', _dark: '{colors.violet.dark.10}' } },
  11: { value: { base: '{colors.violet.light.11}', _dark: '{colors.violet.dark.11}' } },
  12: { value: { base: '{colors.violet.light.12}', _dark: '{colors.violet.dark.12}' } },
  a1: { value: { base: '{colors.violet.light.a1}', _dark: '{colors.violet.dark.a1}' } },
  a2: { value: { base: '{colors.violet.light.a2}', _dark: '{colors.violet.dark.a2}' } },
  a3: { value: { base: '{colors.violet.light.a3}', _dark: '{colors.violet.dark.a3}' } },
  a4: { value: { base: '{colors.violet.light.a4}', _dark: '{colors.violet.dark.a4}' } },
  a5: { value: { base: '{colors.violet.light.a5}', _dark: '{colors.violet.dark.a5}' } },
  a6: { value: { base: '{colors.violet.light.a6}', _dark: '{colors.violet.dark.a6}' } },
  a7: { value: { base: '{colors.violet.light.a7}', _dark: '{colors.violet.dark.a7}' } },
  a8: { value: { base: '{colors.violet.light.a8}', _dark: '{colors.violet.dark.a8}' } },
  a9: { value: { base: '{colors.violet.light.a9}', _dark: '{colors.violet.dark.a9}' } },
  a10: { value: { base: '{colors.violet.light.a10}', _dark: '{colors.violet.dark.a10}' } },
  a11: { value: { base: '{colors.violet.light.a11}', _dark: '{colors.violet.dark.a11}' } },
  a12: { value: { base: '{colors.violet.light.a12}', _dark: '{colors.violet.dark.a12}' } },
}
